export default __webpack_public_path__ + "static/media/history_slide_2.80d36490.jpg";